module.exports = __webpack_public_path__ + "img/feedback7.945cc15a.webp";